import { useTranslation } from 'react-i18next';

import { useCollaborativeList } from '@mygpt/app';

import Collaborative from '@/components/Collaborative';
import ContainerHeader from '@/components/Headers/ContainerHeader';

const CreatePage = () => {
  const { t } = useTranslation();
  const { data } = useCollaborativeList();
  return (
    <>
      <ContainerHeader title={t('page.collaborate_title')} description={t('page.collaborate_description')} />
      <div style={{ position: 'relative', height: `${data.length > 0 ? 'auto' : 'calc(100vh - 150px)'}` }}>
        <Collaborative />
      </div>
    </>
  );
};

export default CreatePage;
